import { ReactNode, useEffect } from 'react';

type ThemeValues = Record<string, string>;

interface ThemeProviderProps {
  theme: ThemeValues;
  children: ReactNode;
}

export function ThemeProvider({ theme, children }: ThemeProviderProps) {
  useEffect(() => {
    const root = document.documentElement;
    Object.entries(theme || {}).forEach(([key, value]) => {
      root.style.setProperty(`--${key}`, value);
    });
  }, [theme]);

  return <>{children}</>;
}
